import { defineMessages } from 'react-intl'

export default defineMessages({
  whatislifesum_1_heading: {
    id: 'whatislifesum_1_heading',
    defaultMessage: 'Find a Diet you love',
  },
  whatislifesum_1_text: {
    id: 'whatislifesum_1_text',
    defaultMessage:
      'Find a nutritious Diet that fits your lifestyle and food preferences. Take charge of your daily habits with one of the many ongoing Diets including Clean Eating and High Protein.',
  },
  whatislifesum_2_heading: {
    id: 'whatislifesum_2_heading',
    defaultMessage: 'Start a simplified Meal Plan',
  },
  whatislifesum_2_text: {
    id: 'whatislifesum_2_text',
    defaultMessage:
      'Follow a 7-21 day Meal Plan and get four pre-planned recipes a day. Depending on your health goals, there are many Meal Plans to choose from including Keto Burn and Vegan for a week.',
  },
  whatislifesum_3_heading: {
    id: 'whatislifesum_3_heading',
    defaultMessage: 'Enjoy hundreds of tasty and nutritious recipes',
  },
  whatislifesum_3_text: {
    id: 'whatislifesum_3_text',
    defaultMessage:
      'Enjoy hundreds of easy-to-cook recipes filled with nutritious and tasty food. All of the recipes include information about their nutritional value so you can keep track of your daily energy intake.',
  },
  whatislifesum_4_heading: {
    id: 'whatislifesum_4_heading',
    defaultMessage: 'Use the helpful barcode scanner',
  },
  whatislifesum_4_text: {
    id: 'whatislifesum_4_text',
    defaultMessage:
      'Identify your food items with the super easy-to-use barcode scanner. Scan the item, log it and get the nutritional information you need to stay on track.',
  },
  whatislifesum_5_heading: {
    id: 'whatislifesum_5_heading',
    defaultMessage: 'Track your way to success',
  },
  whatislifesum_5_text: {
    id: 'whatislifesum_5_text',
    defaultMessage:
      'Track your activities and what you eat with the help of our food-, exercise- and water trackers to maintain a balanced everyday life.',
  },
  whatislifesum_6_heading: {
    id: 'whatislifesum_6_heading',
    defaultMessage: 'Create your own health journey',
  },
  whatislifesum_6_text: {
    id: 'whatislifesum_6_text',
    defaultMessage:
      'To help you reach your goals and customize your health journey you can add your favorite meals, food items, recipes and exercises to your Favorites.',
  },
})
